storefrontApp.service('threadService', ['$http', function ($http) {
    return {
        getThreadDetails: function () {
            return $http.get('getthreaddetails');
        },
        getThreadConeImageNames: function () {
            return $http.get('getthreadconeimagenames');
        },
        getThreadDetailsById: function (prdMfg,prdcode) {
            return $http.get(('getthreaddetailsbyid/' + prdMfg + '/' +  prdcode).toLowerCase());
        },
        getThreadMfgForConversionChart: function (processStep, threadMfg, threadType,seachText) {
            return $http.get('storefrontapi/getthreaddfgforconversionchart?processStep=' + processStep + '&threadMfg=' + threadMfg + '&threadType=' + threadType + '&seachText=' + seachText);
        },
        getCompleteMatchingThreadsList: function (red, green, blue,tolerance,threadMfg) {
            return $http.get('storefrontapi/getcompletematchingthreadslist?red=' + red + '&green=' + green + '&blue=' + blue + '&tolerance=' + tolerance + '&threadMfg=' + threadMfg);
        },
        getSuggestedColors: function (red, green, blue,tolerance,threadMfg,targetMfg) {
            return $http.get('storefrontapi/getsuggestedcolors?red=' + red + '&green=' + green + '&blue=' + blue + '&tolerance=' + tolerance + '&threadMfg=' + threadMfg + '&targetMfg=' + targetMfg);
        }
    }
}]);
